// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Importing registers Bootstrap Data API listeners (collapse, dropdown, etc.)
import * as bootstrap from "bootstrap"

// Keep the import alive for esbuild (avoids tree-shaking the Data API)
window.bootstrap = bootstrap
